// import React from 'react'

// function CultHistory() {
//   return (
//     <div>

//     </div>
//   )
// }

// export default CultHistory

import React, { useState } from "react";
import {
  FaMountain,
  FaGavel,
  FaLandmark,
  FaPeopleCarry,
  FaMapMarkedAlt,
} from "react-icons/fa";

const historyData = [
  {
    title: "Mormon Pioneer History",
    description:
      "The arrival and settlement of Mormon pioneers in the mid-19th century significantly shaped Utah's culture, values, and social structures. This includes their journey, establishment of communities, and religious practices.",
    icon: <FaPeopleCarry className="text-orange-600 text-2xl" />,
  },
  {
    title: "Native American History and Culture",
    description:
      "Utah has a long and rich history of Native American tribes, including the Ute, Paiute, Shoshone, Goshute, and Navajo. Their traditions, art, and history are vital to understanding the state's cultural landscape.",
    icon: <FaMapMarkedAlt className="text-red-500 text-2xl" />,
  },
  {
    title: "Early Exploration and Mountain Male",
    description:
      "Before the Mormon pioneers, Spanish explorers and fur trappers traversed the region, leaving their mark on place names and local lore.",
    icon: <FaMountain className="text-green-600 text-2xl" />,
  },
  {
    title: "Mining and Industrial History",
    description:
      "The development of mining and other industries brought diverse populations to Utah and influenced its economic and social development.",
    icon: <FaGavel className="text-blue-500 text-2xl" />,
  },
  {
    title: "Statehood and Modern History",
    description:
      "Utah's journey to statehood and its subsequent development into the modern era, including its role in the Civil Rights movement and other national events.",
    icon: <FaLandmark className="text-purple-600 text-2xl" />,
  },
];

function CultHistory() {
  const [activeIndex, setActiveIndex] = useState(null);

  return (
    <div className="w-full max-w-3xl mx-auto my-10 px-4">
      <h2 className="text-3xl font-bold text-center mb-8 text-gray-700">
        Utah Cultural History
      </h2>
      {historyData.map((item, index) => (
        <div key={index} className="mb-4 border rounded-lg shadow bg-white">
          <button
            className="w-full flex items-center justify-between px-4 py-3 text-left bg-[#014cb2] text-white hover:text-black hover:bg-gray-700"
            onClick={() => setActiveIndex(index === activeIndex ? null : index)}
          >
            <div className="flex items-center gap-3">
              {item.icon}
              {/* <span className="font-semibold text-white hover:text-black z-50">{item.title}</span> */}
              <span className="font-semibold text-white hover:text-black">
                {item.title}
              </span>
            </div>
            <span>{index === activeIndex ? "−" : "+"}</span>
          </button>
          {index === activeIndex && (
            <div className="px-6 pb-4 text-gray-700">{item.description}</div>
          )}
        </div>
      ))}
    </div>
  );
}

export default CultHistory;
